import React from "react";
import styled from "styled-components";
import {SectionTitle} from "../../Sections";
import {ActionRow} from "./ActionRow";
import {logAction} from "../../../../logging/logEvent";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 250px;
    font-size: 12px;
`;

const TitleText = styled.div`
    margin-right: 12px;
`;

const Spacer = styled.div`
    height: 45px;
    flex-shrink: 0;
    flex-grow: 0;
`;

const ActivitiesContainer = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
`;

const AuthorActivity = ({activity = [], ideaActions}) => {
    const onClick = (action) => {
        const {ideaId, ideaType, dateTime} = action;
        logAction({
            type: "HOMEPAGE_ACTIVITY_CLICKED",
            ideaId: ideaId,
            action: action.action,
            bloomberg: action.recommendation.bloomberg,
            direction: ideaType,
            activityTimestamp: dateTime
        });
        ideaActions.showDetail(ideaId);
    };

    return <Container className="t-activity">
        <SectionTitle>
            <TitleText>Activity</TitleText>
        </SectionTitle>
        <Spacer/>
        <ActivitiesContainer>
            {
                activity.map((action, index) =>
                    <ActionRow key={`${action.dateTime}-${index}`}
                               className='t-idea-action'
                               onClick={onClick}
                               action={action}/>
                )
            }
        </ActivitiesContainer>
    </Container>
};

export default AuthorActivity;